import React, { useState, useEffect } from 'react';
import './EditUsernameModal.css';

const EditUsernameModal = ({ isOpen, onClose, onEditUsername, currentUsername }) => {
  const [formData, setFormData] = useState({
    username: currentUsername || '',
    currentPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (currentUsername) {
      setFormData({ username: currentUsername, currentPassword: '' });
    } else {
      setFormData({ username: '', currentPassword: '' });
    }
    setError(null);
  }, [currentUsername, isOpen]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // Validazioni
    if (!formData.username.trim()) {
      setError('Il nome utente non può essere vuoto');
      setLoading(false);
      return;
    }

    if (formData.username.trim().length < 3) {
      setError('Il nome utente deve essere di almeno 3 caratteri');
      setLoading(false);
      return;
    }

    if (formData.username.trim() === currentUsername) {
      setError('Il nome utente è identico a quello attuale');
      setLoading(false);
      return;
    }

    try {
      await onEditUsername(formData.username.trim(), formData.currentPassword);
      onClose();
    } catch (err) {
      setError(err.message || 'Errore durante l\'aggiornamento del nome utente');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {/* X nell'angolo in alto a destra */}
        <button className="modal-close-button" onClick={onClose}>
          ×
        </button>
        
        <div className="modal-header">
          <h2>Modifica Nome Utente</h2>
        </div>
        
        <div className="modal-body">
          <form onSubmit={handleSubmit} className="modal-form">
            <div className="form-group">
              <label htmlFor="currentPassword">Password Attuale</label>
              <input
                type="password"
                id="currentPassword"
                name="currentPassword"
                value={formData.currentPassword}
                onChange={handleChange}
                required
                placeholder="Inserisci password attuale"
                autoFocus
              />
            </div>

            <div className="form-group">
              <label htmlFor="username">Nuovo Nome Utente</label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
                placeholder="Inserisci nuovo nome utente"
              />
            </div>

            {error && (
              <div className="error-message">
                ⚠️ {error}
              </div>
            )}

            <div className="modal-actions">
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={onClose}
                disabled={loading}
              >
                Annulla
              </button>
              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'Aggiornamento in corso...' : 'Aggiorna'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditUsernameModal;
